import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExtensionsApiService } from '@pages/checkout-app/services/api/extensions.api.service';
import { IExtensionGroup } from './models/extension-group.models';

@Injectable({
  providedIn: 'root',
})
export class ExtensionGroupsService {
  private readonly basePath = 'admin/v1/extension-groups';

  constructor(private extensionsApiService: ExtensionsApiService) {}

  loadGroups(): Observable<IExtensionGroup[]> {
    return this.extensionsApiService.get(this.basePath);
  }

  loadGroupById(id: number): Observable<IExtensionGroup> {
    return this.extensionsApiService.get(`${this.basePath}/${id}`);
  }

  createGroup(group: Partial<IExtensionGroup>): Observable<IExtensionGroup> {
    return this.extensionsApiService.post(this.basePath, group);
  }

  updateGroup(id: number, group: Partial<IExtensionGroup>): Observable<IExtensionGroup> {
    return this.extensionsApiService.patch(`${this.basePath}/${id}`, group);
  }

  deleteGroup(id: number): Observable<void> {
    return this.extensionsApiService.delete(`${this.basePath}/${id}`);
  }
}
